import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faHandWave } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Round pill with a waving hand, shown over video while a user's hand is
 * raised. It pops in when created, so render it only while the hand is up.
 * The parent positions it and sizes it with `--pill-size` (see the
 * video-pill mixin).
 */
@Component({
  selector: 'andor-raised-hand-badge',
  standalone: true,
  imports: [FaIconComponent, TranslatePipe],
  templateUrl: './raised-hand-badge.html',
  styleUrl: './raised-hand-badge.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RaisedHandBadge {
  protected readonly faHandWave = faHandWave;
}
